module.exports = __webpack_public_path__ + "static/media/Resume.53a35ab9.pdf";